import { render, staticRenderFns } from "./CaRights.vue?vue&type=template&id=05ccf240&scoped=true"
import script from "./CaRights.vue?vue&type=script&lang=js"
export * from "./CaRights.vue?vue&type=script&lang=js"
import style0 from "./CaRights.vue?vue&type=style&index=0&id=05ccf240&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ccf240",
  null
  
)

export default component.exports